import React from 'react';
import * as Tabs$1 from '@radix-ui/react-tabs';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A set of layered sections of content—known as tab panels—that are displayed one at a time.
 */
/**
 * Contains all the tabs component parts.
 */
const Root = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Tabs$1.Root, props, children);
};
Root.displayName = "Root";
/**
 *
 * Contains the triggers that are aligned along the edge of the active content.
 *
 */
const List = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Tabs$1.List, props, children);
};
List.displayName = "List";
/**
 * The button that activates its associated content.
 */
const Trigger = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Tabs$1.Trigger, props, children);
};
Trigger.displayName = "Trigger";
/**
 * Contains the content associated with each trigger.
 */
const Content = ({
  value,
  asChild,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Tabs$1.Content, _extends({
    value: value,
    asChild: asChild
  }, props), children);
};
Content.displayName = "Content";
// Exports
Root.displayName = 'Tabs';
Trigger.displayName = 'Trigger';
Content.displayName = 'TContent';
List.displayName = 'List';

/**
 * Provides a list of tabs that a user can select from to switch between multiple tab panels.
 */
var Tabs = Object.assign(Root, {
  Trigger,
  Content,
  List
});

export { Content, List, Root, Trigger, Tabs as default };
